import { useState, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";


/**
 * @typedef {Object} UpdateAgreementPayload
 * @property {number} institution_id
 * @property {string} billing_mode
 * @property {number} duration_value
 * @property {string} duration_unit
 * @property {number} base_licenses
 * @property {number} price_per_unit
 */

/**
 * Admin - Update Agreement
 */
export const useUpdateAgreement = () => {
  const { user, fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  /**
   * @param {number} agreementId
   * @param {UpdateAgreementPayload} payload
   */
  const updateAgreement = useCallback(
    async (agreementId, payload) => {
      if (!user?.token || !agreementId) return;

      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        const response = await fetchWithAuth(
          `${apiUrl}/school/agreement/update/${agreementId}`,
          {
            method: "PUT", // or PATCH if backend expects
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        

        const result = await response.json();

        if (!result.success) {
          throw new Error(result.message || "Failed to update agreement");
        }

        setSuccess(true);
        return result;
      } catch (err) {
        console.error("Agreement Update Error:", err);
        setError(err.message || "Something went wrong");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [apiUrl, fetchWithAuth, user]
  );

  return {
    updateAgreement,
    loading,
    error,
    success,
  };
};
